'use strict';

var React = require('react');

var SvgButtonMinor = function SvgButtonMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5v4.95l-4.014-2.59c-1.71-1.104-3.953.19-3.853 2.224l.145 2.916h-6.778a1.5 1.5 0 0 1-1.5-1.5v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.131 9.999a.5.5 0 0 1 .77-.445l4.869 3.142a.5.5 0 0 1-.021.853l-1.425.823 1.229 2.128a1 1 0 1 1-1.732 1l-1.23-2.128-1.424.822a.5.5 0 0 1-.75-.408l-.286-5.786z"
  }));
};

exports.SvgButtonMinor = SvgButtonMinor;
